module.exports = __webpack_public_path__ + "img/SKMG14_map3.60ca4190.jpg";